import { SHOW_ALERT, HIDE_ALERT, HIDE_MODAL_ALERT, NEW_HIDE_ALERT } from "../types"

export const showAlert = (alert) => ({
	type: SHOW_ALERT,
	payload: alert,
})

export const showAlertAction = (alert) => ({
	type: SHOW_ALERT,
	payload: alert,
})

export const hideAlert = () => ({
	type: HIDE_ALERT,
	payload: null,
})

export const hideModalAlertAction = () => ({
	type: HIDE_MODAL_ALERT,
	payload: null,
})

export const newHideAlert = () => ({
	type: NEW_HIDE_ALERT,
	payload: null,
})

export const hideAlertAction = () => ({
	type: HIDE_ALERT,
	payload: null,
})

export const alertActions = {
	showAlertAction,
	hideAlertAction,
	hideModalAlertAction,
}
